import { ModalCustom } from "components/ModalCustom";
import { Icone, ModalBody } from "./style";
import { FaExclamation } from "react-icons/fa";
import { IPreencherATPVLote } from "../../interfaces/IPreencherATPVLote";

interface IProps {
  show: boolean;
  handleClose: () => void;
  onConfirm: (dados: IPreencherATPVLote | null) => void;
  dados: IPreencherATPVLote | null;
  onCancel: (dados: IPreencherATPVLote | null) => void;
}

export function ModalCertezaProcessosDuplicadosLoteAtpv({
  show,
  handleClose,
  onConfirm,
  dados,
  onCancel,
}: IProps) {
  return (
    <ModalCustom
      show={show}
      handleClose={handleClose}
      title="Duplicação de processos"
      centered={true}
      footer={true}
      footerConfirmButton={true}
      onConfirm={() =>
        onConfirm(dados ? { evitarProcessosDuplicados: "NAO", ...dados } : null)
      }
      onCancel={() =>
        onCancel(dados ? { evitarProcessosDuplicados: "SIM", ...dados } : null)
      }
      confirmButtonText="Sim"
      cancelButtonText="Evitar duplicidade"
    >
      <ModalBody>
        <Icone>
          <FaExclamation />
        </Icone>
        Alguns veículos já possuem processos criados com as mesmas
        características. Deseja criar novos processos para estes veículos mesmo
        assim?
      </ModalBody>
    </ModalCustom>
  );
}
